(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[410],{

/***/ 6696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Tr": function() { return /* binding */ Tr; },
/* harmony export */   "hr": function() { return /* binding */ Thead; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "p3": function() { return /* binding */ Tbody; }
/* harmony export */ });
/* unused harmony exports TableCaption, TableContainer, Tfoot, useTableStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2067);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8387);
// ../../../react-shim.js


// src/table.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/table.tsx

var [TableStylesProvider, useTableStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `TableStylesContext`,
  errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
});
var Table = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Table", props);
  const { className, ...tableProps } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(TableStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.table */ .m$.table, {
    ref,
    __css: styles.table,
    className: cx("chakra-table", className),
    ...tableProps
  }));
});
Table.displayName = "Table";

// src/table-container.tsx

var TableContainer = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const { overflow, overflowX, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.div */ .m$.div, {
    ref,
    className: cx("chakra-table__container", className),
    ...rest,
    __css: {
      display: "block",
      whiteSpace: "nowrap",
      WebkitOverflowScrolling: "touch",
      overflowX: overflow ?? overflowX ?? "auto",
      overflowY: "hidden",
      maxWidth: "100%"
    }
  });
});

// src/table-caption.tsx

var TableCaption = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const { placement = "bottom", ...rest } = props;
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.caption */ .m$.caption, {
    ...rest,
    ref,
    __css: {
      ...styles.caption,
      captionSide: placement
    }
  });
});
TableCaption.displayName = "TableCaption";

// src/thead.tsx

var Thead = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.thead */ .m$.thead, {
    ...props,
    ref,
    __css: styles.thead
  });
});

// src/tbody.tsx

var Tbody = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.tbody */ .m$.tbody, {
    ...props,
    ref,
    __css: styles.tbody
  });
});

// src/tfooter.tsx

var Tfoot = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.tfoot */ .m$.tfoot, {
    ...props,
    ref,
    __css: styles.tfoot
  });
});

// src/th.tsx

var Th = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(({ isNumeric, ...rest }, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.th */ .m$.th, {
    ...rest,
    ref,
    __css: styles.th,
    "data-is-numeric": isNumeric
  });
});

// src/tr.tsx

var Tr = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.tr */ .m$.tr, {
    ...props,
    ref,
    __css: styles.tr
  });
});

// src/td.tsx

var Td = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(({ isNumeric, ...rest }, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.td */ .m$.td, {
    ...rest,
    ref,
    __css: styles.td,
    "data-is-numeric": isNumeric
  });
});



/***/ }),

/***/ 7738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[mdpage]",
      function () {
        return __webpack_require__(9322);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8641);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _utils_markdownmapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7923);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var next_mdx_remote__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3659);






// @ts-ignore collections prop used for header
const PrivacyPage = (param)=>{
    let { content , title , collections  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: title + " - Blickfang",
                openGraph: {
                    type: "website",
                    locale: "de_DE",
                    title: title + " - Blickfang",
                    images: [
                        {
                            url: "https://blckfng.com/images/full_page_image.jpg"
                        }
                    ]
                },
                twitter: {
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Center */ .M5, {
                p: "20px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                    maxW: "900px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_5__/* .MDXRemote */ .R, {
                        components: _utils_markdownmapping__WEBPACK_IMPORTED_MODULE_2__/* .components */ .w,
                        ...content
                    })
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPage);


/***/ }),

/***/ 7923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ components; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3038);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6696);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_next_chakra_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1963);





// Possible values: https://mdxjs.com/advanced/typescript
const components = {
    _ignore: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6,
    em: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
            as: "em",
            children: children
        });
    },
    blockquote: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Alert */ .bZ, {
            status: "success",
            variant: "left-accent",
            children: children
        });
    },
    code: (param)=>{
        let { className , children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Code */ .EK, {
            p: 2,
            className: className || null,
            children: children
        });
    },
    del: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
            as: "del",
            children: children
        });
    },
    thematicBreak: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .iz,
    a: (param)=>{
        let { href , children  } = param;
        {}
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_next_chakra_link__WEBPACK_IMPORTED_MODULE_3__/* .NextChakraLink */ .D, {
            color: "#b0b0b0",
            href: href,
            children: children
        });
    },
    img: (param)=>{
        let { alt , src  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            height: 200,
            width: 200,
            alt: alt,
            src: src
        });
    },
    p: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
            pb: "2",
            children: children
        });
    },
    ul: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .UnorderedList */ .QI, {
            children: children
        });
    },
    ol: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .OrderedList */ .GS, {
            ml: "2rem",
            children: children
        });
    },
    li: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .ListItem */ .HC, {
            children: children
        });
    },
    h1: (param)=>{
        let { children  } = param;
        return heading(1, children);
    },
    h2: (param)=>{
        let { children  } = param;
        return heading(2, children);
    },
    h3: (param)=>{
        let { children  } = param;
        return heading(3, children);
    },
    h4: (param)=>{
        let { children  } = param;
        return heading(4, children);
    },
    h5: (param)=>{
        let { children  } = param;
        return heading(5, children);
    },
    h6: (param)=>{
        let { children  } = param;
        return heading(6, children);
    },
    inlineCode: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Code */ .EK, {
            children: children
        });
    },
    table: (param)=>{
        let { children  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Table */ .iA, {
            variant: "simple",
            children: children
        });
    },
    tr: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__.Tr,
    td: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__.Td,
    thead: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Thead */ .hr,
    th: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__.Th,
    tbody: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Tbody */ .p3
};
function heading(level, children) {
    const sizes = [
        "2xl",
        "xl",
        "lg",
        "md",
        "sm",
        "xs"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
        css: {
            hyphens: "auto"
        },
        my: 4,
        // @ts-ignore
        as: "h".concat(level),
        size: sizes["".concat(level - 1)],
        children: children
    });
}


/***/ }),

/***/ 1032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(1720);

module.exports = __webpack_require__(6584);


/***/ }),

/***/ 2746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
const jsxRuntime = __webpack_require__(1032)

module.exports.c = jsxRuntime


/***/ }),

/***/ 3659:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ MDXRemote; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var react_namespaceObject = {};
__webpack_require__.r(react_namespaceObject);
__webpack_require__.d(react_namespaceObject, {
  "MDXContext": function() { return MDXContext; },
  "MDXProvider": function() { return MDXProvider; },
  "useMDXComponents": function() { return useMDXComponents; },
  "withMDXComponents": function() { return withMDXComponents; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var jsx_runtime = __webpack_require__(2746);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/lib/index.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = compat_module["default"].createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return compat_module["default"].createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = compat_module["default"].useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return compat_module["default"].useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return compat_module["default"].createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}

;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js




if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,compat_module.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,compat_module.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,compat_module.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ...react_namespaceObject, ...jsx_runtime/* jsxRuntime */.c } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (compat_module["default"].createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (compat_module["default"].createElement(MDXProvider, { components: components },
        compat_module["default"].createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? compat_module["default"].createElement("div", null, content) : content;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,962,888,179], function() { return __webpack_exec__(7738); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);